import { Pagination } from '~/composables';
import { Article, Articles } from '../types';

const getPagination = (articles: Articles): Pagination => ({
  currentPage: articles?.page_info?.current_page || 1,
  totalPages: articles?.page_info?.total_pages || 1,
  totalItems: articles?.total_count || 0,
  itemsPerPage: articles?.page_info?.page_size || 9,
  pageOptions: [10, 40, 80],
});

const getArticles = (articles: Articles): Article[] => articles?.items || [];

const articlesGetters = {
  getPagination,
  getArticles,
};

export default articlesGetters;
